import { useEffect } from "react";
import { useTolgee } from "@tolgee/react";
import useSearchParam from "hooks/useSearchParam";
import { selectUser } from "api/firebase";
import { stagedLanguageStore } from "store/localization/staged-language.store";
import { TOLGEE_LANGUAGE_STORAGE_KEY } from "tools/localization/constants";

export const useLangParamPreselect = () => {
  const lang = useSearchParam("lang");
  const tolgee = useTolgee();

  useEffect(() => {
    if (!lang) return;
    if (localStorage.getItem(TOLGEE_LANGUAGE_STORAGE_KEY)) return;

    tolgee.changeLanguage(lang);

    if (!selectUser()) {
      stagedLanguageStore.getState().stage(lang);
    }
  }, [lang, tolgee]);
};
